import {ReviewerIdentity} from '../../reviewers/ReviewerIdentity'
import type {Reviewer} from '@github-ui/dotcom-schema/types/pull_requests/v1/reviewer'
import styles from './DelegatedFromTeams.module.css'

// Renders the "Assigned from <team>" delegation note with rich, linked team identities.
// Mirrors OnBehalfOfTeams, but tailored to the reviewer-delegation ("assigned from") context.
export function DelegatedFromTeams({teams}: {teams: Reviewer[]}) {
  if (teams.length === 0) return null

  return (
    <span className={styles.delegationNote}>
      Assigned from{' '}
      {teams.map((team, i) => (
        <span key={team.id.toString()} className={styles.teamList}>
          <ReviewerIdentity reviewer={team} withAvatar={false} inline />
          {i < teams.length - 1 && <span className={styles.separator}>, </span>}
        </span>
      ))}
    </span>
  )
}
